var _excluded = ["onIntersection", "intersectionOptions"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';

var IntersectionObserver = function IntersectionObserver(_ref) {
  var _intersectionOptions$;

  var onIntersection = _ref.onIntersection,
      intersectionOptions = _ref.intersectionOptions,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var isIntersectionObserverSupported = useMemo(function () {
    return typeof window !== 'undefined' && typeof window.IntersectionObserver !== 'undefined';
  }, []);

  var _useInView = useInView(_objectSpread(_objectSpread({
    rootMargin: '0px'
  }, intersectionOptions), {}, {
    // Always skip if IntersectionObserver API is not supported
    skip: ((_intersectionOptions$ = intersectionOptions === null || intersectionOptions === void 0 ? void 0 : intersectionOptions.skip) !== null && _intersectionOptions$ !== void 0 ? _intersectionOptions$ : false) || !isIntersectionObserverSupported
  })),
      intersectionObserverRef = _useInView.ref,
      isInView = _useInView.inView; // Call 'onIntersection' every time intersection changes


  useEffect(function () {
    if (isIntersectionObserverSupported) {
      onIntersection(isInView);
    }
  }, [isIntersectionObserverSupported, isInView, onIntersection]);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "intersection-observer-ref"
  }, divProps, {
    ref: isIntersectionObserverSupported ? intersectionObserverRef : undefined
  }));
};

export default IntersectionObserver;